import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const RocketryButton = styled(Button)(({ theme }) => ({
    borderRadius: "30px",
    padding: "12px 28px",
    fontWeight: 600,
    fontSize: "1rem",
    textTransform: "none",

    backgroundColor: (theme) => theme.palette.missionGold.main, // primary orange
    color: "black",
    boxShadow: "0px 4px 12px rgba(30, 136, 229, 0.4)",
    transition: "all 0.3s ease",
    "&:hover": {
        backgroundColor: "rgba(224, 168, 0,0.8)",
        boxShadow: "0px 6px 18px rgba(21, 101, 192, 0.5)",
        transform: "translateY(-2px)",
    },
    "&:active": {
        transform: "translateY(0)",
        boxShadow: "0px 3px 8px rgba(21, 101, 192, 0.3)",
    },
}));

export default RocketryButton;